import { OUTREACH_DEPARTMENT } from './outreach.js';
export const PROSPECTING_DEPARTMENTS = {
    [OUTREACH_DEPARTMENT]: { profiles: 'Profiles', found: 'Prospects', outreach: true, channels: ['email', 'warm_intro', 'call', 'visit'], approveAs: 'client' },
    fundraising: { profiles: 'Investor profiles', found: 'Prospects', outreach: false, channels: ['warm_intro'], approveAs: 'investor' },
    food_science: { profiles: 'Supplier profiles', found: 'Found', outreach: false, channels: ['visit'], approveAs: 'vendor' },
};
export const prospectingOf = (department) => PROSPECTING_DEPARTMENTS[department] ?? null;
//# sourceMappingURL=prospecting-departments.js.map